import React from "react";
import { useTranslation } from "react-i18next";
import ModalBootstrap from "components/bootstrap/ModalBootstrap";

type Props = {
  onConfirm: () => void;
  onCancle: () => void;
  modalShow: boolean;
  setModalShow: (show: boolean) => void;
  title: string;
  contentText: string;
};
const ConfirmationModal = ({
  modalShow,
  setModalShow,
  title,
  contentText,
  onConfirm,
  onCancle,
}: Props) => {
  const { t } = useTranslation();
  const buttons = (
    <div className="flexContainer space-between">
      <button
        type="button"
        className="btn blue half-width"
        onClick={() => {
          onConfirm();
        }}
      >
        {t("confirmation")}
      </button>
      <button
        type="button"
        className="btn white half-width"
        onClick={() => {
          onCancle();
        }}
      >
        {t("cancel")}
      </button>
    </div>
  );

  return (
    <ModalBootstrap
      onHide={() => setModalShow(false)}
      show={modalShow}
      title={title}
      dialogClassName="little-modal"
      isWithFooter={false}
    >
      <div>
        {contentText}
        {buttons}
      </div>
    </ModalBootstrap>
  );
};

export default ConfirmationModal;
